export default {"src":"/_next/static/media/nftfy-busd.0b0015ab.svg","height":54,"width":48};